// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u5gg+","links":"Footer_links__xJ8g+","link":"Footer_link__c5ir1","colophon":"Footer_colophon__xqQZt"};